import axios from "axios";
import createAuthRefreshInterceptor from "axios-auth-refresh";

import { createStore, applyMiddleware } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import ReduxThunk from "redux-thunk";
import storage from "redux-persist/lib/storage";

import rootReducer from "./reducers";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"],
  blacklist: ["common", "companyProfile", "campaigns", "rewards"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(persistedReducer, applyMiddleware(ReduxThunk));

const refreshAuthLogic = (failedRequest) => {
  const state = store.getState();
  const refreshToken = state.auth.refresh_token;

  return axios
    .post(`${process.env.REACT_APP_API_ENDPOINT}/api/v1/refresh-token`, {
      refreshToken,
    })
    .then((res) => {
      store.dispatch({ type: "SET_AUTH_DATA", payload: res.data.data });

      return Promise.resolve();
    })
    .catch((e) => {
      console.log("e", e);
      store.dispatch({
        type: "LOGOUT_USER",
      });
      window.location.href = "/";
    });
};

axios.interceptors.request.use((request) => {
  const accessToken = store.getState().auth.access_token;
  request.headers["Authorization"] = `Bearer ${accessToken}`;

  return request;
});

// Instantiate the interceptor (you can chain it as it returns the axios instance)
createAuthRefreshInterceptor(axios, refreshAuthLogic);

let persistor = persistStore(store);

export default { store, persistor };
